var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Spinner",class:{ error: _vm.error }},[_c('div',{staticClass:"content"},[_c('SpinnerAnimation',{staticStyle:{"color":"var(--primary)"}})],1),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }